<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.quote_apply_invent')">
        <QTHInvent></QTHInvent>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.quote_apply_bom')">
        <QTHBom></QTHBom>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.quote_apply_route')">
        <QTHRoute></QTHRoute>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.quote_apply_other_cost')">
        <QTHTransport></QTHTransport>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.quote_apply_invent_price_confirm')">
        <QTHInventPrice></QTHInventPrice>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import QTHInvent from './QTHInvent.vue';
import QTHBom from './QTHBom.vue';
import QTHRoute from './QTHRoute.vue';
import QTHTransport from './QTHTransport.vue';
import QTHInventPrice from './QTHInventPrice.vue';
export default {
  components: {
    QTHInvent,
    QTHBom,
    QTHRoute,
    QTHTransport,
    QTHInventPrice
  },
  data() {
    return {
      tab_index: 0
    }
  },
}
</script>
